import { markdownToSanitizedHTML } from './markdown-to-html/markdownToSanitizedHTML';

/**
 * Matches the two ways an image can reach the rendered HTML. Parsing is the
 * authority — this only exists so the common no-image case skips it, since
 * callers run per grid cell.
 */
const IMAGE_CANDIDATE = /!\[|<img/i;

/**
 * Text previews drop images, so callers that only show a preview need to know
 * whether anything was left out.
 */
export const containsImage = (markdownText: string): boolean =>
  IMAGE_CANDIDATE.test(markdownText) &&
  markdownToSanitizedHTML(markdownText, 'permissive').includes('<img');
